import AuthService from '../services/auth.service';
import User from "@/models/user";
import {ActionTree, Module} from "vuex";
import {ProfileState} from "@/models/profileState";


const user: User = JSON.parse(<string>localStorage.getItem('user'));
const initialState: ProfileState = user
    ? {
        version: JSON.parse(process.env.VUE_APP_PACKAGE_JSON || '').version,
        user: user, status: {loggedIn: true}, barColor: 'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
        drawer: null,
    }
    : {
        version: JSON.parse(process.env.VUE_APP_PACKAGE_JSON || '').version,
        user: undefined, status: {}, barColor: 'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
        drawer: null,
    };
const actions: ActionTree<ProfileState, ProfileState> = {
    login({commit}, user: User): any {
        // eslint-disable-next-line no-console
        console.log("login");
        return AuthService.login(user).then(
            user => {
                commit('loginSuccess', user);
                return Promise.resolve(user);
            },
            error => {
                commit('loginFailure', null);
                return Promise.reject(error.response.data);
            }
        );
    },
    logout({commit}) {
        // eslint-disable-next-line no-console
        console.log("logout");
        AuthService.logout();
        commit('logout');
    },
    register({commit}, user: User) {
        // eslint-disable-next-line no-console
        console.log("register");
        return AuthService.register(user).then(
            response => {
                commit('registerSuccess');
                return Promise.resolve(response.data);
            },
            error => {
                commit('registerFailure');
                return Promise.reject(error.response.data);
            }
        );
    }
};

export const auth: Module<ProfileState, ProfileState> = {
    namespaced: true,
    state: initialState,
    actions: actions,
    getters: {
        appVersion: (state) => {
            return state.version
        }
    },
    mutations: {
        loginSuccess(state: any, user: User) {
            // eslint-disable-next-line no-console
            console.log("loginSuccess");
            state.status = {loggedIn: true};
            state.user = user;
        },
        loginFailure(state: any) {
            // eslint-disable-next-line no-console
            console.log("loginFailure");
            state.status = {};
            state.user = null;
        },
        logout(state: any) {
            // eslint-disable-next-line no-console
            console.log("logout");
            state.status = {};
            state.user = null;
        },
        registerSuccess(state: any) {
            // eslint-disable-next-line no-console
            console.log("registerSuccess");
            state.status = {};
        },
        registerFailure(state: any) {
            // eslint-disable-next-line no-console
            console.log("registerFailure");
            state.status = {};
        }
    }
};
